import type {Shop} from "~/types/user";

class ShopNotFound extends Error {
    statusCode: number = 404
}

export const useShopData = async (handle?: string): Promise<Ref<Shop>|undefined> => {

    if (!handle) {
        return undefined
    }

    const {data, error } = usePublicApi(
        `/shops/${handle}`,
        {
            transform: (result: any) => ({
                avatarUrl: result.avatar && result.avatar[0] ? result.avatar[0].downloadURL : '',
                bannerUrl: result.banner && result.banner[0] ? result.banner[0].downloadURL : '',
                logoUrl: result.logo && result.logo[0] ? result.logo[0].downloadURL : '',
                ...result
            }) as Shop
        }
    )

    if (error.value) {
        console.log(error.value)
        throw showError({
            statusCode: 404,
            message: "Shop not found"
        })
    }
    return data
}
